export const USER_1_KOKORIN = { id: "KOKORIN", label: "Кокорін" };
export const USER_2_KOROVCHENO = { id: "KOROVCHENO", label: "Коровчено" };
export const USERS = [USER_1_KOKORIN, USER_2_KOROVCHENO];
